import React, { Component } from "react"; 
import { profile, branch, alert, total, float, toFixed, format_date, random_charactor, GET, POST, PUT, DELETE, loading, Status, params, required, DatePicker, Select, BtnIcon, Swal, Pagination, Switch, Navbar, Modal, Resizer } from "../components/CustomComponent.js";
export default class PaymentHistory extends Component {
  constructor(props) {
      super(props);
      this.state = {
       document_no: "",
        company_name: "",
        created_at: "",
        ref_number: "",
warehouse_name: "",

        customer_name: "",
        customer_phone: "",

        is_vat: false,
        amount: "0.00",
        amount_deposit: "0.00",
        total_pay: "0.00",
        discount: 0,
delivery_cost: 0,
        transaction_list: [],

        remark: ""
      };
    }
  
    async componentDidMount() {
      loading(false);
      if(params("uid")){
        await this.Get(params("uid"));
        }
      window.print();
    }
  Get = async (uid) => {
        loading(true);
        let result = await GET("admin/stock-activities/list", { uid });
      if (result?.status) {
        const item = result.data;
        this.setState({
          document_no: item.document_no,
          company_name: item.supplier?.company_name || "",
          created_at: item.created_at,
          ref_number: item.ref_number || "",
          warehouse_name: item.warehouse?.name || "",

          customer_name: item.customer?.full_name,
          customer_phone: item.customer?.phone,
          transaction_list: item.transaction_list || [],

          is_vat: item.is_vat,
          amount: item.amount,
          amount_deposit: item.amount_deposit,
          total_pay: item.total_pay,
          discount: item.discount || 0,
          delivery_cost: item.delivery_cost || 0,

          remark: item.remark || ""
        });
      }
      loading(false);
    };
    render() {
      const {document_no,company_name,created_at,ref_number,warehouse_name,customer_name,customer_phone, transaction_list,is_vat,amount,amount_deposit,total_pay,discount,delivery_cost, remark} = this.state;
      return (
      <div className="mx-auto bg-white p-5 pdf" style={{ width: 1116, height: 1579 }}>
        <h1 className="fw-bold text-center mb-3">ห.จ.ก. เชียงใหม่เซียงกงอะไหล่ยนต์ (2000) สำนักงานใหญ่</h1>
        <h4 className="fw-bold text-center mb-3">61 ถ.ซุปเปอร์ไฮเวย์ เชียงใหม่ - ลำปาง ต.ช้างเผือก อ.เมืองเชียงใหม่ จ.เชียงใหม่</h4>
        <h5 className="fw-bold text-center mb-3">โทร. (053) 211747, 213301, 215323 แฟกซ์ (053) 210060</h5>
        <h2 className="fw-bold text-center mb-4">ใบรับสินค้า</h2>
        <div className="row mb-3">
          <div className="col-6"><h5 className="fw-bold mb-3">เลขที่เอกสาร : {document_no}</h5></div>
          <div className="col-6"><h5 className="fw-bold mb-3">ชื่อบริษัทจำหน่าย : {company_name}</h5></div>
          <div className="col-6"><h5 className="fw-bold mb-3">วันที่เอกสาร : {format_date(created_at,"dd mmmm yyyy","th")}</h5></div>
          <div className="col-6"><h5 className="fw-bold mb-3">เลขที่อ้างอิง PO : {ref_number}</h5></div>
          <div className="col-6"><h5 className="fw-bold mb-3">คลังสินค้า : {warehouse_name}</h5></div>
        </div>
        <table className="table table-bordered mb-4 text-16">
          <thead>
            <tr className="fw-bold border-0">
              <td className="text-center border-1 wpx-70">ลำดับที่</td>
              <td className="text-center border-1">รหัส/ชื่อสินค้า</td>
              <td className="text-center border-1">Serial Number</td>
              <td className="text-center border-1">จำนวน</td>
              <td className="text-end border-1">ราคา/หน่วย</td>
              <td className="text-end border-1">ส่วนลด</td>
              <td className="text-end border-1">ราคาหลัง<br/>หักส่วนลด</td>
              <td className="text-end border-1">มูลค่ารวม</td>
            </tr>
          </thead>
          <tbody>
            {transaction_list.map((item, index)=>(
              <tr className="border-0">
                <td className="text-center" style={{border:"0px 1px"}}>{index + 1}</td>
                <td className="text-start" style={{border:"0px 1px"}}>{item.product_code} {item.product_name}</td>
                <td className="text-center" style={{border:"0px 1px"}}>{item.serial_number?.toString() || "-"}</td>
                <td className="text-center" style={{border:"0px 1px"}}>{item.qty}</td>
                <td className="text-end" style={{border:"0px 1px"}}>{toFixed(item.unit_price)}</td>
                <td className="text-end" style={{border:"0px 1px"}}>{toFixed(item.discount)}</td>
                <td className="text-end" style={{border:"0px 1px"}}>{toFixed((Number(item.unit_price) * Number(item.qty)) - Number(item.discount))}</td>
                <td className="text-end" style={{border:"0px 1px"}}>{toFixed((Number(item.unit_price) * Number(item.qty)) - Number(item.discount))}</td>
              </tr>
            ))}
          </tbody>
          <tfoot className="">
            <tr className="border-0">
              <td className="fw-bold text-end" style={{border:0,borderTop:"1px solid #000"}} colSpan={7}>รวมเป็นเงิน</td>
              <td className="text-end border-1">{(()=>{
                let _total = 0;
                transaction_list.forEach((tx)=>{
                  _total += (Number(tx.unit_price) * Number(tx.qty)) - Number(tx.discount);
                });
                return toFixed(_total);
              })()}</td>
            </tr>
            <tr className="border-0">
              <td className="fw-bold text-end border-0" colSpan={7}>ส่วนลด</td>
              <td className="text-end border-1">{toFixed(discount)}</td>
            </tr>
            <tr className="border-0">
              <td className="fw-bold text-end border-0" colSpan={7}>ราคาหลังหักส่วนลด</td>
              <td className="text-end border-1">{(()=>{
                let _total = 0;
                transaction_list.forEach((tx)=>{
                  _total += (Number(tx.unit_price) * Number(tx.qty)) - Number(tx.discount);
                });
                return toFixed(_total-Number(discount));
              })()}</td>
            </tr>
            <tr className="border-0">
              <td className="fw-bold text-end border-0" colSpan={7}>ภาษีมูลค่าเพิ่ม 7%</td>
              <td className="text-end border-1">{(()=>{
                let _total = 0;
                transaction_list.forEach((tx)=>{
                  _total += (Number(tx.unit_price) * Number(tx.qty)) - Number(tx.discount);
                });
                return is_vat ? toFixed(_total * 0.07): "0.00";
              })()}</td>
            </tr>
            <tr className="border-0">
              <td className="fw-bold text-end border-0" colSpan={7}>ค่าส่ง</td>
              <td className="text-end border-1">{toFixed(delivery_cost)}</td>
            </tr>
            <tr className="border-0">
              <td className="fw-bold text-end border-0" colSpan={7}>จำนวนเงินรวมทั้งหมด</td>
              <td className="text-end border-1">{amount}</td>
            </tr>
          </tfoot>
        </table>
        <h5 className="fw-bold mb-4">หมายเหตุ : {remark || "-"}</h5>
      </div>
    );
  }
}
